import { useState } from "react";
import { AdaptedButton } from "../../components/adaptedButton";
import { View, StyleSheet, TouchableOpacity, Image} from "react-native";

export function Page4({ handleClick }) {
    const [selectedValue, setSelectedValue] = useState('');
    const handleButtonClick = (name, value) => {
        setSelectedValue(value)
        handleClick(name, value);
    };
    return (
<View style={styles.imagesRow}>
    <View>
    <TouchableOpacity
        style={styles.imageContainer}
        onPress={() => handleButtonClick('skintone', 'Very Fair/Very Light')}
      >
        <Image
          source={require('../../../assets/skinTone/Very Fair_Very Light.png')}
          style={[
            styles.image,
            selectedValue === 'Very Fair/Very Light' && styles.selectedImage,
          ]}
        />
      </TouchableOpacity>
    </View>
    <View>
    <TouchableOpacity
        style={styles.imageContainer}
        onPress={() => handleButtonClick('skintone', 'Fair/Light')}
      >
        <Image
          source={require('../../../assets/skinTone/Fair_Light.png')}
          style={[
            styles.image,
            selectedValue === 'Fair/Light' && styles.selectedImage,
          ]}
        />
      </TouchableOpacity>
    </View>
    <View>
    <TouchableOpacity
        style={styles.imageContainer}
        onPress={() => handleButtonClick('skintone', 'Medium/Olive')}
      >
        <Image
          source={require('../../../assets/skinTone/Medium_Olive.png')}
          style={[
            styles.image,
            selectedValue === 'Medium/Olive' && styles.selectedImage,
          ]}
        />
      </TouchableOpacity>
    </View>
    <View>
    <TouchableOpacity
        style={styles.imageContainer}
        onPress={() => handleButtonClick('skintone', 'Light Brown')}
      >
        <Image
          source={require('../../../assets/skinTone/Light Brown.png')}
          style={[
            styles.image,
            selectedValue === 'Light Brown' && styles.selectedImage,
          ]}
        />
      </TouchableOpacity>
    </View>
    <View>
    <TouchableOpacity
        style={styles.imageContainer}
        onPress={() => handleButtonClick('skintone', 'Medium Brown')}
      >
        <Image
          source={require('../../../assets/skinTone/Medium Brown.png')}
          style={[
            styles.image,
            selectedValue === 'Medium Brown' && styles.selectedImage,
          ]}
        />
      </TouchableOpacity>
    </View>
    <View>
    <TouchableOpacity
        style={styles.imageContainer}
        onPress={() => handleButtonClick('skintone', 'Very Dark')}
      >
        <Image
          source={require('../../../assets/skinTone/Very Dark.png')}
          style={[
            styles.image,
            selectedValue === 'Very Dark' && styles.selectedImage,
          ]}
        />
      </TouchableOpacity>
    </View>
</View>

    );
}

const styles = StyleSheet.create({
    imageContainer: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 10,
        justifyContent: 'space-around',
        flexWrap: 'wrap',
      },
    imagesRow:{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        //padding: 10,
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    image: {
        //flex: 1,
        //maxHeight:60,
        //maxWidth: 60,
        height: 84.5,
        width: 130,
        alignItems: 'center',
        justifyContent: 'center',
        //display: 'flex',
        //borderRadius: '100%',
        //border: '3px solid red'
      },
      selectedImage: {
        height: 84.5,
        width: 130,
        borderColor: '#3B1C15',
        borderRadius: 20,
        borderWidth: 2,
        //backgroundColor: '#EFE7DE'

      },
});

{/* <View style={styles.imageContainer}>
<AdaptedButton handleClick={handleButtonClick} field={'skintone'} fieldValue={'Very Fair/Very Light'} selected={selectedValue === 'Very Fair/Very Light'} />
</View>
<View style={styles.imageContainer}>
<AdaptedButton handleClick={handleButtonClick} field={'skintone'} fieldValue={'Fair/Light'} selected={selectedValue === 'Fair/Light'} />
</View>
<View style={styles.imageContainer}>
<AdaptedButton handleClick={handleButtonClick} field={'skintone'} fieldValue={'Olive or Medium'} selected={selectedValue === 'Olive or Medium'} />
</View>
<View style={styles.imageContainer}>
<AdaptedButton handleClick={handleButtonClick} field={'skintone'} fieldValue={'Light Brown'} selected={selectedValue === 'Light Brown'} />
</View>
<View style={styles.imageContainer}>
<AdaptedButton handleClick={handleButtonClick} field={'skintone'} fieldValue={'Dark Brown'} selected={selectedValue === 'Dark Brown'} />
</View>
<View style={styles.imageContainer}>
<AdaptedButton handleClick={handleButtonClick} field={'skintone'} fieldValue={'Very Dark'} selected={selectedValue === 'Very Dark'} />
</View>
<View style={styles.imageContainer}>
<AdaptedButton handleClick={handleButtonClick} field={'skintone'} fieldValue={'Not sure'} selected={selectedValue === 'Not sure'} />
</View> */}